<template>
  <v-app>
    <navbar v-if="token" />

    <v-main light>
      <router-view 
        :class="{
          'pr-12 pl-9': rps === 'lg' && token,
          'px-5': rps !== 'lg',
          'my-5': token
        }"/>
    </v-main>
  </v-app>
</template>

<script>
  import { get, post, put, destroy } from "./service/Axios";
  import firebaseapp from "firebase";
  import firebase from "./plugins/Firebase";
  export default {
    components: {
      navbar: () => import(/* webpackPrefetch: true */ '@/components/navbar.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      token () {
        return this.$store.state.token
      }
    },
    created() {
      
    },
    methods: {
      
    }
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#content {
  padding: 0px;
}
</style>
